<template>
  <div>
    <span class="light-button" v-if="!isActive" v-on:click="activateInput">{{callToAction}}</span>
    <input
      ref="contentInput"
      v-if="isActive"
      v-model="listTitle"
      @blur="createNewList"
      autofocus
      placeholder="New session subject"
    />
  </div>
</template>

<script>
import api from "@/api"

import createList from "../../gql/lists/createList.gql"

export default {
  data() {
    return {
      listTitle: "",
      callToAction: "Create new session",
      isActive: this.statusDefault
    };
  },
  methods: {
    createNewList: function() {

      if (!this.listTitle || this.listTitle === "") {
        this.isActive = false;
        return;
      }

      let owner_id = this.$store.state.user.id;
      let title = this.listTitle;

      this.$apollo
        .mutate({
          mutation: createList,
          variables: {
            owner_id,
            title
          }
        })
        .then(async res => {
          const list_id = res.data.insert_lists_one.id;
          const user_id = owner_id;

          await api.addUserToList(list_id, user_id, "active");

          api.createEventTracking("list-created-input", "list-created", user_id, true);

          this.isActive = !this.isActive;
          this.clearData();
        });
    },
    clearData: function() {
      this.listTitle = "";
    },
    activateInput: function() {
      this.isActive = !this.isActive;
      setTimeout(() => {
        this.$refs.contentInput.focus();
      });
    }
  },
  props: {
    statusDefault: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

span {
  color: theme.$primary-color;
  font-weight: 900;
  margin-top: 8px;
}

input {
  outline: none;
  background: theme.$white-background;
  border: 1px solid theme.$primary-color;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 6px 8px;
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>